import { z } from "zod";

function templateSchema(max: number) {
  return z
    .string()
    .trim()
    .min(1)
    .max(max)
    .refine(
      (value) =>
        !/[{}]|<\/?[a-z!][^>]*>/i.test(value.replaceAll("{product_title}", "")),
      "Only plain text and {product_title} are supported",
    );
}

/** 规则 id 仅在所属 Tenant 内寻址；数组顺序就是优先级。 */
export const proactiveRuleSchema = z
  .strictObject({
    id: z.string().trim().min(1).max(128),
    enabled: z.boolean().default(false),
    trigger: z
      .enum(["product_idle", "element_visible", "store_entry"])
      .default("product_idle"),
    waitSeconds: z.number().int().min(1).max(300).optional(),
    prompt: templateSchema(200),
    question: templateSchema(1000),
    /** CSS 语法在服务端保存时校验，避免解析器进入挂件包。 */
    selector: z.string().trim().default(""),
  })
  .transform((rule) => ({
    ...rule,
    waitSeconds: rule.waitSeconds ?? (rule.trigger === "product_idle" ? 4 : 2),
    selector: rule.trigger === "element_visible" ? rule.selector : "",
  }))
  .refine(
    (rule) =>
      rule.trigger !== "element_visible" ||
      !rule.enabled ||
      rule.selector.length > 0,
    { path: ["selector"], message: "Enabled element rules require a selector" },
  );

export const proactiveRulesSchema = z
  .array(proactiveRuleSchema)
  .refine(
    (rules) => new Set(rules.map((rule) => rule.id)).size === rules.length,
    "Rule ids must be unique within a Tenant",
  );

export type ProactiveRule = z.infer<typeof proactiveRuleSchema>;
